















import {Component, Prop, Vue} from "vue-property-decorator";
@Component({})
export default class CategoryViewSelect extends Vue {
    @Prop({}) value!:string;
    @Prop({}) items!:any;
    @Prop({default:true}) required!:boolean;
    updateValue (value:string) {
        this.$emit('input', value)
    }
    async created(){
        if(this.items == null){
            let categoryView = await this.$http.get("categoryView");
            this.items = categoryView.data;
        }
    }
}
